var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppFooter',{staticClass:"display-flex flex-space-between--center px-12 py-4"},[_c('div',{staticClass:"dummy-div"}),_c('span',{staticClass:"flex-centerize"},[_vm._t("default")],2),_c('div',{staticClass:"tertiary-link-style cancel-btn ml-8",on:{"click":function($event){return _vm.$emit('cancel')}}},[_vm._v("Cancel")])])
}
var staticRenderFns = []

export { render, staticRenderFns }